import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
  type?: string;
}
export const ROUTES: RouteInfo[] = [
  //{ path: '/dashboard', title: 'Dashboard', icon: 'ni-tv-2 text-orange', class: '' },
  { path: '/schooladmin', title: 'School Owners', icon: 'ni-circle-08 text-orange', class: ''},
  { path: '/driveradmin', title: 'Driver Owners', icon: 'ni-circle-08 text-orange', class: ''},
  { path: '/schools', title: 'Schools', icon: 'ni-hat-3 text-orange', class: '' },
  { path: '/routers', title: 'Routers', icon: 'ni-map-big text-orange', class: '' },
  { path: '/drivers', title: 'Drivers', icon: 'ni-user-run text-orange', class: '' },
  // { path: '/user-profile', title: 'User profile',  icon:'ni-single-02 text-yellow', class: '' },
  // { path: '/tables', title: 'Tables',  icon:'ni-bullet-list-67 text-red', class: '' },
  // { path: '/login', title: 'Login',  icon:'ni-key-25 text-info', class: '' },
  // { path: '/register', title: 'Register',  icon:'ni-circle-08 text-pink', class: '' }
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  public menuItems: any[];
  public isCollapsed = true;

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit() {

    this.authService.loginState.subscribe(res => {
      this.menuItems = ROUTES.filter(menuItem => {
        if (menuItem.path == '/schooladmin') {
          if (this.authService.currentUser.role !== 'superadmin')
            return false;
          return true;
        };

        if (menuItem.path == '/driveradmin') {
          if (this.authService.currentUser.role !== 'superadmin')
            return false;
          return true;
        };
      });
    });


    if (this.authService.currentUser) {

      this.menuItems = ROUTES.filter(menuItem => {
        if (menuItem.path == '/schooladmin') {
          if (this.authService.currentUser.role !== 'superadmin')
            return false;
          return true;
        };

        if (menuItem.path == '/driveradmin') {
          if (this.authService.currentUser.role !== 'superadmin')
            return false;
          return true;
        };

        return true;
      });

    }

    //this.menuItems = ROUTES;

    this.router.events.subscribe((event) => {
      this.isCollapsed = true;
    });
  }

  signOut($event) {
    $event.stopPropagation();
    $event.preventDefault();
    this.authService.signOut();
  }
}

